<div class="main">
  <header-menu></header-menu>

  <div class="colab-manager-wrapper">
    <div class="content colab-manager-content no-padding">
      <div class="colab-manager-content-component fade-in-animation">

        <breadbrumbs [items]="breadcrumbItems" ></breadbrumbs>

        <h1>Meus Vouchers</h1>

        <div class="tabs">
          <div
            class="tab-item active"
            [class.active]="currentTab === 'available'"
            (click)="currentTab = 'available'"
          >
            Disponíveis
          </div>
          <div
            class="tab-item"
            [class.active]="currentTab === 'expired'"
            (click)="currentTab = 'expired'"
          >
            Expirados
          </div>
        </div>

        <overlay-loading *ngIf="loading"></overlay-loading>

        <vouchers-list
          *ngIf="!loading && currentTab === 'available'"
          [vouchers]="availableVouchers"
          [vouchersToGenerate]="vouchersToGenerate"
          [noVouchersMessage]="'Você ainda não possui vouchers disponíveis.'">
        </vouchers-list>

        <vouchers-list
          *ngIf="!loading && currentTab === 'expired'"
          [vouchers]="expiredVouchers"
          [noVouchersMessage]="'Você ainda não possui vouchers expirados.'">
        </vouchers-list>

      </div>
    </div>
  </div>

</div>
